import CommandArgGroupInfoFuncUtil from './CommandArgGroupInfoFuncUtil';

export default class CommandArgFuncUtil
{

    static bindCommandArgFunc(commandArg)
    {
        commandArg.getEditorValue = CommandArgFuncUtil.getEditorValue.bind(commandArg);
        commandArg.getGroupInfo = CommandArgFuncUtil.getGroupInfo.bind(commandArg);
        commandArg.getCurrentRecord = CommandArgFuncUtil.getCurrentRecord.bind(commandArg);
        commandArg.getJoinGroupRecord = CommandArgFuncUtil.getJoinGroupRecord.bind(commandArg);
        commandArg.getSelectedRecords = CommandArgFuncUtil.getSelectedRecords.bind(commandArg);
        commandArg.getAllRecords = CommandArgFuncUtil.getAllRecords.bind(commandArg);
        commandArg.getAllMaps = CommandArgFuncUtil.getAllMaps.bind(commandArg);
        commandArg.getSelectedMaps = CommandArgFuncUtil.getSelectedMaps.bind(commandArg);
        commandArg.getCurrentMap = CommandArgFuncUtil.getCurrentMap.bind(commandArg);
        commandArg.getCurrentQuery = CommandArgFuncUtil.getCurrentQuery.bind(commandArg);
        commandArg.getFormQuery = CommandArgFuncUtil.getFormQuery.bind(commandArg);
        commandArg.getDialogFieldValue = CommandArgFuncUtil.getDialogFieldValue.bind(commandArg);
        for(let key in commandArg.mapGroups)
        {
            let argInfo = commandArg.mapGroups[key];
            if(argInfo)
            {
                argInfo.getCurrentRecord = CommandArgGroupInfoFuncUtil.getCurrentRecord.bind(argInfo);
                argInfo.getCurrentMap = CommandArgGroupInfoFuncUtil.getCurrentMap.bind(argInfo);
                argInfo.getSelectedRecordsByCurrentRecord = CommandArgGroupInfoFuncUtil.getSelectedRecordsByCurrentRecord.bind(argInfo);
                argInfo.getSelectedMapsByCurrentRecord = CommandArgGroupInfoFuncUtil.getSelectedMapsByCurrentRecord.bind(argInfo);
                argInfo.getSelectedRecords = CommandArgGroupInfoFuncUtil.getSelectedRecords.bind(argInfo);
                argInfo.getAllRecords = CommandArgGroupInfoFuncUtil.getAllRecords.bind(argInfo);

                argInfo.getAllMaps = CommandArgGroupInfoFuncUtil.getAllMaps.bind(argInfo);
                argInfo.getCurrentQuery = CommandArgGroupInfoFuncUtil.getCurrentQuery.bind(argInfo);
                argInfo.getFormQuery = CommandArgGroupInfoFuncUtil.getFormQuery.bind(argInfo);
            }
        }

        if(commandArg.joinGroup)
        {
            let argInfo = commandArg.joinGroup;
            argInfo.getCurrentRecord = CommandArgGroupInfoFuncUtil.getCurrentRecord.bind(argInfo);
            argInfo.getCurrentMap = CommandArgGroupInfoFuncUtil.getCurrentMap.bind(argInfo);
            argInfo.getSelectedRecordsByCurrentRecord = CommandArgGroupInfoFuncUtil.getSelectedRecordsByCurrentRecord.bind(argInfo);
            argInfo.getSelectedMapsByCurrentRecord = CommandArgGroupInfoFuncUtil.getSelectedMapsByCurrentRecord.bind(argInfo);
            argInfo.getSelectedRecords = CommandArgGroupInfoFuncUtil.getSelectedRecords.bind(argInfo);
            argInfo.getAllRecords = CommandArgGroupInfoFuncUtil.getAllRecords.bind(argInfo);

            argInfo.getAllMaps = CommandArgGroupInfoFuncUtil.getAllMaps.bind(argInfo);
            argInfo.getCurrentQuery = CommandArgGroupInfoFuncUtil.getCurrentQuery.bind(argInfo);
            argInfo.getFormQuery = CommandArgGroupInfoFuncUtil.getFormQuery.bind(argInfo);
        }

    }

    static getEditorValue(controlName)
    {
        if(!this.mapEditors)
            return null;
        if(!controlName)
            return null;
        if(!this.mapEditors.hasOwnProperty(controlName))
        {
            return null;
        }
        let value = this.mapEditors[controlName];
        return value;
    }

    static getGroupInfo(groupAlias)
    {
        if(!this.mapGroups)
            return null;
        if(groupAlias)
        {
            return this.mapGroups[groupAlias];
        }
        if(this.defaultGroupAlias)
        {
            return this.mapGroups[this.defaultGroupAlias];
        }
        for(let key in this.mapGroups)
        {
            return this.mapGroups[key];
        }
        return null;
    }

    static getCurrentRecord()
    {
        let gi = this.getGroupInfo();
        if(!gi)return null;
        return gi.getCurrentRecord();
    }

    static getJoinGroupRecord()
    {
        if(!this.joinGroup)
            return null;
        return this.joinGroup.getCurrentRecord();
    }

    static getSelectedRecords()
    {
        let gi = this.getGroupInfo();
        if(!gi)
            return [];
        return gi.getSelectedRecords();
    }

    static getAllRecords()
    {
        let gi = this.getGroupInfo();
        if(!gi)
            return [];
        return gi.getAllRecords();
    }

    static getAllMaps()
    {
        let gi = this.getGroupInfo();
        if(!gi)
            return [];
        return gi.getAllMaps();
    }

    static getSelectedMaps()
    {
        let gi = this.getGroupInfo();
        if(!gi)
            return [];
        return gi.getSelectedMaps();
    }

    static getCurrentMap()
    {
        let gi = this.getGroupInfo();
        if(!gi)
            return null;
        return gi.getCurrentMap();
    }

    static getCurrentQuery()
    {
        let gi = this.getGroupInfo();
        if(!gi)
            return null;
        return gi.getCurrentQuery();
    }

    static getFormQuery()
    {
        let gi = this.getGroupInfo();
        if(!gi)
            return null;
        return gi.getFormQuery();
    }

    static getDialogFieldValue(dialogFieldId)
    {
        if(!this.argObject)return null;
        if(!dialogFieldId)return null;
        return this.argObject[dialogFieldId];
    }
}


// WEBPACK FOOTER //
// ./src/utils/CommandArgFuncUtil.js